import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const PUBLIC_PAGES = new Set(["/", "/hi", "/login", "/register", "/app", "/requests"]);

export default function SiteViewTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  useEffect(() => {
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    if (PUBLIC_PAGES.has(pathname)) {
      // Analytics must never prevent navigation or display errors to visitors.
      api.post("/statistics/view").catch(() => {});
    }
  }, [pathname]);
  return null;
}
